<template>
  <div>
    <filter-targeted-content :filterStatus="filterStatus" @filter-item="handleFilterStatus" />

    <div class="container mx-auto">
      <empty
        v-if="loaded && surveys.length === 0"
        title="Their is no surveys"
        message="It's time to create new surveys !"
      />

      <div v-else-if="loaded && surveys.length > 0">
        <table-target-content
          :items="surveys"
          :type="'Surveys'"
          :onDelete="handleRemoveSurvey"
          @on-duplicate="handleDuplicatSurvey"
          @on-stats-click="handleOpenStats"
          @on-comments-click="handleOpenComments"
        />
      </div>

      <modal-confirmation
        v-if="deleteSurveyModalConfirmation"
        :open="deleteSurveyModalConfirmation"
        type="danger"
        messageTitle="Warnings !"
        message="Do you really want to remove this NPS survey ? This actions cannot be undone."
        messageAction="Yes, I'm sure !"
        @execute="confirmRemoveSurvey"
        @close="deleteSurveyModalConfirmation = false"
      />

      <surveys-ui-modal-stats
        v-if="isStatsOpen && surveyStatsId"
        :open="isStatsOpen && !!surveyStatsId"
        :close="handleCloseStats"
        :id="surveyStatsId"
      />

    </div>
  </div>
</template>

<script>
import Empty from '@/components/box-entity-empty.vue'
import ModalConfirmation from '@/components/others/utils/ModalConfirmation.vue'
import TableTargetContent from './table-targeted-content.vue'
import FilterTargetedContent from '@/components/common/ui/form/filter-targeted-content.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SurveyUiList',

  components: { Empty, ModalConfirmation, TableTargetContent, FilterTargetedContent },

  data() {
    return {
      loaded: false,
      surveys: [],
      stats: [],
      isStatsOpen: false,
      surveyStatsId: null,
      deleteSurveyModalConfirmation: false,
      surveyToDelete: null,
      filterStatus: 'all',
      isCommentsOpen: false,
      surveyCommentsId: null
    }
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  computed: {
    ...mapGetters('surveys', {
      allSurveys: 'surveys',
      getByStatus: 'getByStatus'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  methods: {
    ...mapActions('surveys', ['loadSurveys', 'removeSurvey', 'addSurvey']),

    init() {
      this.loadSurveys().then(() => {
        this.loaded = true
        this.surveys = this.allSurveys
        this.getUrlTargetToString(this.surveys)
      })
    },
    getUrlTargetToString(surveys) {
      for (let survey of surveys) {
        let urlString = ""
        survey.url_target_list.forEach((path, index) => {
          if (index === 0) {
            urlString += path
          } else {
            urlString += ', ' + path
          }
        })
        survey.url_target_string = urlString;
      }
    },
    handleRemoveSurvey(survey) {
      this.surveyToDelete = survey
      this.deleteSurveyModalConfirmation = true
    },
    handleDuplicatSurvey(surveyId) {
      const surveyToClone = this.surveys.find(survey => survey.id === surveyId)
      const surveyClone = {
        ...surveyToClone,
        name: `Copy of ${surveyToClone.name}`,
        status: 'disable'
      }

      this.addSurvey(surveyClone)
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.survey.duplicated'),
            type: 'success'
          })
        })
        .catch(response => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
        })
    },
    confirmRemoveSurvey() {
      this.removeSurvey(this.surveyToDelete)
      this.deleteSurveyModalConfirmation = false
    },
    cancelRemoveSurvey() {
      this.deleteSurveyModalConfirmation = false
    },
    handleCloseStats() {
      this.isStatsOpen = false
    },
    handleOpenStats(surveyId) {
      this.surveyStatsId = surveyId
      this.isStatsOpen = true
    },
    handleFilterStatus(status) {
      this.filterStatus = status
      this.surveys = this.getByStatus(status)
    },
    handleCloseComments() {
      this.isCommentsOpen = false
    },
    handleOpenComments(surveyId) {
      this.surveyCommentsId = surveyId
      this.isCommentsOpen = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/surveys/ui/list.vue